import { combineReducers } from 'redux'
import calendar from './calendar';
import gamesTable from './gamesTable';

export default combineReducers({
  calendar,
  gamesTable
});
